import { render, staticRenderFns } from "./AttachmentItem.vue?vue&type=template&id=57e9e5f8&scoped=true"
import script from "./AttachmentItem.vue?vue&type=script&lang=js"
export * from "./AttachmentItem.vue?vue&type=script&lang=js"
import style0 from "./AttachmentItem.vue?vue&type=style&index=0&id=57e9e5f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e9e5f8",
  null
  
)

export default component.exports